/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey, ModelKeyProvider } from '@typescript-kit/core';
import { HttpApplicationError } from './model/http-error.model';

export class CoreInitializer {

  static initialize() {
    ModelKeyProvider.registerKey(HttpApplicationError, CoreErrorKey.HTTP_ERROR);
  }

}
